
import { Vue, Component, Prop } from 'vue-property-decorator'

import DialogTemplate from '@/_components/dialog/template/template.vue'
import ProjectGroupForm from '@/views/Project/Settings/Components/projectGroupForm.vue'

@Component({
    inheritAttrs: false,
    name: 'PostProjectGroupDialog',
    components: { DialogTemplate, ProjectGroupForm },
})
export default class PostProjectGroupDialog extends Vue {
    @Prop({ required: true }) props!: any

    isLoading = false
    isValid = false

    async submit() {
        const newProjectGroup = await (this.$refs.projectGroupForm as ProjectGroupForm).submit()
        this.$emit('close', newProjectGroup)
    }

    cancel() {
        this.$emit('close', false)
    }
}
